// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hnKSN2 {
  --message-size: var(--font-size-sm);
}

.SS33O4 {
  --message-size: var(--font-size-sm);
}

.enUZ4s {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: var(--spacing-0-5);
}

.s0k6UB {
  height: 12px;
  width: 12px;
}

.V4TO8A {
  margin: 0;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-stronger);
  font-size: var(--message-size);
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/Input/InputMessage.module.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,uCAAuC;EACvC,mCAAmC;EACnC,8BAA8B;AAChC","sourcesContent":[".large {\n  --message-size: var(--font-size-sm);\n}\n\n.small {\n  --message-size: var(--font-size-sm);\n}\n\n.messageContainer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n  gap: var(--spacing-0-5);\n}\n\n.messageIcon {\n  height: 12px;\n  width: 12px;\n}\n\n.message {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-stronger);\n  font-size: var(--message-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"large": `hnKSN2`,
	"small": `SS33O4`,
	"messageContainer": `enUZ4s`,
	"messageIcon": `s0k6UB`,
	"message": `V4TO8A`
};
module.exports = ___CSS_LOADER_EXPORT___;
